//
// locales/glitch/it.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/it';
import localeData from 'react-intl/locale-data/it.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
